import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { DuplicateCompareCard } from "@/components/DuplicateReviewPanel";

export default function DuplicateWarningDialog({ isOpen, onClose, onConfirm, matches = [], current = null }) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg" data-testid="duplicate-warning-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-700">
            <AlertTriangle className="h-5 w-5" />
            Mögliche Duplikate erkannt
          </DialogTitle>
          <DialogDescription>
            Es gibt bereits sehr ähnliche Ausgaben. Vergleiche die Werte — soll der Beleg trotzdem gespeichert werden?
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2 max-h-72 overflow-y-auto">
          {current ? (
            matches.map((m) => (
              <DuplicateCompareCard key={m.id} current={current} other={m} labelCurrent="Neuer Beleg" testId={`duplicate-dialog-compare-${m.id}`} />
            ))
          ) : (
            matches.map((m) => (
              <div key={m.id} className="flex justify-between items-center p-2.5 bg-amber-50 border border-amber-200 rounded-md text-sm">
                <div className="min-w-0">
                  <p className="font-medium truncate">{m.description}</p>
                  <p className="text-xs text-slate-500">
                    {m.date ? new Date(m.date).toLocaleDateString("de-DE") : ""}
                    {m.vendor ? ` · ${m.vendor}` : ""}
                  </p>
                </div>
                <span className="font-semibold text-red-600 flex-shrink-0 ml-3">
                  {parseFloat(m.amount || 0).toLocaleString("de-DE", { minimumFractionDigits: 2 })} €
                </span>
              </div>
            ))
          )}
        </div>

        <div className="flex gap-2 justify-end pt-2">
          <Button variant="outline" onClick={onClose} data-testid="duplicate-cancel-btn">
            Abbrechen
          </Button>
          <Button onClick={onConfirm} data-testid="duplicate-confirm-btn" className="bg-amber-600 hover:bg-amber-700">
            Trotzdem speichern
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
